import { render, staticRenderFns } from "./AnnouncementForm.vue?vue&type=template&id=146a35b4&scoped=true&"
import script from "./AnnouncementForm.vue?vue&type=script&lang=js&"
export * from "./AnnouncementForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a35b4",
  null
  
)

export default component.exports